/* eslint-disable */
import React, { useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";
import { PiFunnelBold } from "react-icons/pi";

import {
  TextField,
  Autocomplete,
  Checkbox,
  FormControlLabel,
} from "@mui/material";

import { MyModal } from "../../../../components/Common/Model/MyModal";
import ModalContainer from "../../../../components/Common/Model/ModalContainer";
import DateFilter from "../../../../components/Common/FilterComponent/DateFilter";

import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { selectKeySkills } from "../../../../redux-store/slices/candidateKanbanSlice";
import { decryptedAdminID, expOptions, sources } from "../../../../utility";

const RegisteredFilterOffcanvas = ({
  filters = {},
  onApply,
  onReset,
  onClose,
  adminList = [],
  options = {},
}) => {
  const { data: reduxSkills = [] } = useSelector(selectKeySkills);
  const loggedId = Number(decryptedAdminID());
  const adminDetails = useSelector((state) => state.adminDetails);
  const isSuperAdmin = adminDetails.roleID == 1;
  const isTeamLeader = localStorage.getItem("teamLeader") == "true";

  const role = isSuperAdmin
    ? "superadmin"
    : isTeamLeader
    ? "teamleader"
    : "admin";

  const getDefaultAssignState = () => {
    if (role === "superadmin") return { assign_to: null, onlyMe: false };
    if (role === "teamleader") return { assign_to: loggedId, onlyMe: true };
    return { assign_to: loggedId, onlyMe: true };
  };

  const [expand, setExpand] = useState({ skill: false, location: false, area: false, job: false });
  const [expType, setExpType] = useState(null);
  const [isCustomExp, setIsCustomExp] = useState(false);

  const skillOptions = reduxSkills.map((item) => ({ id: item.id, label: item.skill }));
  const jobOptions      = options.jobCategory  || [];
  const locationOptions = options.prefLocation || [];
  const areaOptions     = options.prefArea     || [];

  // ── Styles ──
  const chipStyle = { background: "#e0e0e0", padding: "4px 8px", borderRadius: "16px", fontSize: "12px" };
  const moreStyle = { fontSize: "12px", cursor: "pointer" };
  const autoSX = {
    width: "100%",
    "& .MuiAutocomplete-inputRoot": { flexWrap: "wrap", alignItems: "flex-start", gap: "6px", paddingTop: "6px", paddingBottom: "6px" },
  };

  const renderTags = (value, getTagProps, type) => {
    const isExpanded = expand[type];
    const visible = isExpanded ? value : value.slice(0, 3);
    const hiddenCount = value.length - 3;
    return (
      <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px" }}>
        {visible.map((option, index) => (
          <span {...getTagProps({ index })} key={option.id || option.label} style={chipStyle}>
            {option.label}
          </span>
        ))}
        {!isExpanded && hiddenCount > 0 && (
          <span style={moreStyle} onClick={() => setExpand((p) => ({ ...p, [type]: true }))}>+{hiddenCount}</span>
        )}
        {isExpanded && value.length > 3 && (
          <span style={moreStyle} onClick={() => setExpand((p) => ({ ...p, [type]: false }))}>Show less</span>
        )}
      </div>
    );
  };

  // ── Form state ──
  const [form, setForm] = useState({
    mobile_number: "",
    first_name: "",
    job_category: [],
    source: null,
    skill: [],
    pref_location: [],
    pref_area: [],
    qualification: null,
    specification: null,
    exp_from: null,
    exp_to: null,
    created_from: "",
    created_to: "",
    entry_from: "",
    entry_to: "",
    sub_stage_date_from: "",
    sub_stage_date_to: "",
    deActivated: false,
    ...getDefaultAssignState(),
  });

  // ── Init from filters ──
  useEffect(() => {
    setForm((prev) => ({
      ...prev,
      ...filters,
      job_category:        filters.job_category        ?? [],
      skill:               filters.skill               ?? [],
      pref_location:       filters.pref_location       ?? [],
      pref_area:           filters.pref_area           ?? [],
      created_from:        filters.created_from        ?? "",
      created_to:          filters.created_to          ?? "",
      entry_from:          filters.entry_from          ?? "",
      entry_to:            filters.entry_to            ?? "",
      sub_stage_date_from: filters.sub_stage_date_from ?? "",
      sub_stage_date_to:   filters.sub_stage_date_to   ?? "",
      assign_to: filters.assign_to !== undefined ? filters.assign_to : getDefaultAssignState().assign_to,
      onlyMe:    filters.onlyMe    !== undefined ? filters.onlyMe    : getDefaultAssignState().onlyMe,
    }));
  }, [filters]);

  // ── Experience sync ──
  useEffect(() => {
    if (isCustomExp) return;
    if (form.exp_from == null && form.exp_to == null) { setExpType(null); return; }
    const match = expOptions.find(
      (opt) => opt.min === Number(form.exp_from) && opt.max === Number(form.exp_to),
    );
    if (match) { setExpType(match); }
    else { setExpType(expOptions.find((o) => o.label === "Custom")); setIsCustomExp(true); }
  }, [form.exp_from, form.exp_to]);

  const handleChange = (key, value) => setForm((prev) => ({ ...prev, [key]: value }));

  const handleApply = () => { onApply({ ...form, from_source: form.source }); onClose(); };
  const handleReset = () => { onReset(); onClose(); };

  // ── Assign ──
  const mergedAdminList = (() => {
    const exists = adminList.some((a) => a.id === loggedId);
    if (exists) return adminList;
    return [{ id: loggedId, name: "You" }, ...adminList];
  })();

  const assignOptions = (() => {
    const memberOptions = mergedAdminList
      .filter((a) => a.id !== loggedId)
      .map((a) => ({ label: a.name, value: a.id }));

    if (role === "superadmin") {
      return [
        { label: "All",  value: "all"  },
        { label: "Self", value: "self" },
        ...memberOptions,
      ];
    }
    if (role === "teamleader") {
      return [
        { label: "My Team", value: "team" },
        { label: "Self",    value: "self" },
        ...memberOptions,
      ];
    }
    return [];
  })();

  const assignValueObj = (() => {
    if (role === "superadmin") {
      if (form.assign_to == null && form.onlyMe === false)
        return assignOptions.find((o) => o.value === "all") || null;
      if (Number(form.assign_to) === loggedId && form.onlyMe === true)
        return assignOptions.find((o) => o.value === "self") || null;
      return assignOptions.find((o) => Number(o.value) === Number(form.assign_to)) || null;
    }
    if (role === "teamleader") {
      if (form.assign_to == null || form.onlyMe == null)
        return assignOptions.find((o) => o.value === "team") || null;
      if (Number(form.assign_to) === loggedId && form.onlyMe === true)
        return assignOptions.find((o) => o.value === "self") || null;
      if (Number(form.assign_to) === loggedId && form.onlyMe === false)
        return assignOptions.find((o) => o.value === "team") || null;
      return assignOptions.find((o) => Number(o.value) === Number(form.assign_to)) || null;
    }
    return null;
  })();

  const handleAssignChange = (_, selected) => {
    if (!selected) return;
    const val = selected.value;

    if (role === "superadmin") {
      if (val === "all")       setForm((f) => ({ ...f, assign_to: null,        onlyMe: false }));
      else if (val === "self") setForm((f) => ({ ...f, assign_to: loggedId,    onlyMe: true  }));
      else                     setForm((f) => ({ ...f, assign_to: Number(val), onlyMe: true  }));
      return;
    }
    if (role === "teamleader") {
      if (val === "team")      setForm((f) => ({ ...f, assign_to: loggedId,    onlyMe: false }));
      else if (val === "self") setForm((f) => ({ ...f, assign_to: loggedId,    onlyMe: true  }));
      else                     setForm((f) => ({ ...f, assign_to: Number(val), onlyMe: true  }));
      return;
    }
  };

  return (
    <MyModal>
      <ModalContainer>
        <div style={{ maxWidth: "800px" }}>
          {/* HEADER */}
          <div className={styles.header}>
            <span className={styles.headerTitle}>
              <PiFunnelBold size={16} /> Registered Filters
            </span>
            <IoClose className={styles.closeBtn} onClick={onClose} />
          </div>

          <div className={styles.body}>
            {/* BASIC */}
            <div className={styles.section}>
              <p className={styles.sectionLabel}>Basic Info</p>
              <div className={styles.filterGrid}>
                <TextField
                  label="Mobile Number"
                  value={form.mobile_number || ""}
                  onChange={(e) => {
                    let val = e.target.value.replace(/\D/g, "");
                    if (val.length <= 10) handleChange("mobile_number", val);
                  }}
                />
                <TextField
                  label="Name"
                  value={form.first_name || ""}
                  onChange={(e) => handleChange("first_name", e.target.value)}
                />
              </div>
              <div className={styles.filterGrid}>
                <Autocomplete
                  options={sources}
                  value={form.source || null}
                  onChange={(e, val) => handleChange("source", val)}
                  renderInput={(params) => (
                    <TextField {...params} label="Source" size="medium" margin="dense" />
                  )}
                />
                <Autocomplete
                  options={expOptions}
                  value={expType}
                  onChange={(e, selected) => {
                    setExpType(selected);
                    if (!selected) return;
                    if (selected.label === "Custom") {
                      setIsCustomExp(true);
                      setForm((p) => ({ ...p, exp_from: null, exp_to: null }));
                    } else {
                      setIsCustomExp(false);
                      setForm((p) => ({ ...p, exp_from: selected.min, exp_to: selected.max }));
                    }
                  }}
                  getOptionLabel={(opt) => opt.label}
                  isOptionEqualToValue={(o, v) => o.label === v.label}
                  renderInput={(params) => (
                    <TextField {...params} label="Experience" size="medium" margin="dense" />
                  )}
                />
              </div>
              {isCustomExp && (
                <div className={styles.filterGrid}>
                  <TextField
                    label="Min Exp" value={form.exp_from || ""}
                    onChange={(e) => handleChange("exp_from", e.target.value.replace(/\D/g, ""))}
                    margin="dense"
                  />
                  <TextField
                    label="Max Exp" value={form.exp_to || ""}
                    onChange={(e) => handleChange("exp_to", e.target.value.replace(/\D/g, ""))}
                    margin="dense"
                  />
                </div>
              )}
            </div>

            {/* JOB CATEGORY — from options prop */}
            <div className={styles.section}>
              <p className={styles.sectionLabel}>Job Category</p>
              <Autocomplete
                multiple
                options={jobOptions}
                value={(jobOptions).filter((opt) =>
                  (form.job_category || []).includes(opt.label),
                )}
                onChange={(e, val) =>
                  handleChange("job_category", val.map((v) => v.label))
                }
                getOptionLabel={(opt) => opt.label}
                renderTags={(v, g) => renderTags(v, g, "job")}
                renderInput={(params) => <TextField {...params} label="Job Category" />}
                sx={autoSX}
              />
            </div>

            {/* DATE FILTERS */}
            <div className={styles.section}>
              <p className={styles.sectionLabel}>Date Filters</p>
              <div className={styles.filterGrid}>
                <div style={{ marginBottom: "10px" }}>
                  <p style={{ fontSize: "12px", marginBottom: "4px" }}><b>Created Date</b></p>
                  <DateFilter
                    value={{ date_from: form.created_from, date_to: form.created_to }}
                    onChange={(d) => { handleChange("created_from", d.date_from); handleChange("created_to", d.date_to); }}
                  />
                </div>
                <div style={{ marginBottom: "10px" }}>
                  <p style={{ fontSize: "12px", marginBottom: "4px" }}><b>Lead Generated Date</b></p>
                  <DateFilter
                    value={{ date_from: form.entry_from, date_to: form.entry_to }}
                    onChange={(d) => { handleChange("entry_from", d.date_from); handleChange("entry_to", d.date_to); }}
                  />
                </div>
              </div>
              <div>
                <p style={{ fontSize: "12px", marginBottom: "4px" }}><b>Sub Stage Date</b></p>
                <DateFilter
                  value={{ date_from: form.sub_stage_date_from, date_to: form.sub_stage_date_to }}
                  onChange={(d) => { handleChange("sub_stage_date_from", d.date_from); handleChange("sub_stage_date_to", d.date_to); }}
                />
              </div>
            </div>

            {/* SKILLS */}
            <div className={styles.section}>
              <p className={styles.sectionLabel}>Skills</p>
              <Autocomplete
                multiple
                options={skillOptions}
                value={skillOptions.filter((opt) => (form.skill || []).includes(opt.label))}
                onChange={(e, val) => handleChange("skill", val.map((v) => v.label))}
                getOptionLabel={(opt) => opt.label}
                renderTags={(v, g) => renderTags(v, g, "skill")}
                renderInput={(params) => <TextField {...params} label="Key Skills" />}
                sx={autoSX}
              />
            </div>

            {/* LOCATION — from options prop */}
            <div className={styles.section}>
              <p className={styles.sectionLabel}>Location</p>
              <div className={styles.filterGrid}>
                <Autocomplete
                  multiple
                  options={locationOptions}
                  value={(locationOptions).filter((opt) =>
                    (form.pref_location || []).includes(opt.label),
                  )}
                  onChange={(e, val) =>
                    handleChange("pref_location", val.map((v) => v.label))
                  }
                  getOptionLabel={(opt) => opt.label}
                  renderTags={(v, g) => renderTags(v, g, "location")}
                  renderInput={(params) => <TextField {...params} label="Preferred Location" />}
                  sx={autoSX}
                />
                <Autocomplete
                  multiple
                  options={areaOptions}
                  value={(areaOptions).filter((opt) =>
                    (form.pref_area || []).includes(opt.label),
                  )}
                  onChange={(e, val) =>
                    handleChange("pref_area", val.map((v) => v.label))
                  }
                  getOptionLabel={(opt) => opt.label}
                  renderTags={(v, g) => renderTags(v, g, "area")}
                  renderInput={(params) => <TextField {...params} label="Preferred Area" />}
                  sx={autoSX}
                />
              </div>
            </div>

            {/* STATUS */}
            <div className={styles.section}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!form.deActivated}
                    onChange={(e) => handleChange("deActivated", e.target.checked)}
                    sx={{ color: "#169c50", "&.Mui-checked": { color: "#169c50" } }}
                  />
                }
                label="Show Deactivated Candidates"
              />
            </div>

            {/* ASSIGN */}
            {(isSuperAdmin || isTeamLeader) && adminList.length > 0 && (
              <div className={styles.section}>
                <p className={styles.sectionLabel}>Assignment</p>
                <Autocomplete
                  options={assignOptions}
                  value={assignValueObj}
                  onChange={handleAssignChange}
                  getOptionLabel={(opt) => opt?.label || ""}
                  isOptionEqualToValue={(o, v) => o.value === v.value}
                  renderInput={(params) => (
                    <TextField {...params} label="Assign To" margin="dense" />
                  )}
                />
              </div>
            )}
          </div>

          {/* FOOTER */}
          <div className={styles.footer}>
            <button className={styles.resetBtn} onClick={handleReset}>Reset</button>
            <button className={styles.applyBtn} onClick={handleApply}>Apply Filters</button>
          </div>
        </div>
      </ModalContainer>
    </MyModal>
  );
};

export default RegisteredFilterOffcanvas;